import { render } from "./CardsSettingsPanel.vue?vue&type=template&id=583c35b0"
import script from "./CardsSettingsPanel.vue?vue&type=script&lang=js"
export * from "./CardsSettingsPanel.vue?vue&type=script&lang=js"

import "./CardsSettingsPanel.vue?vue&type=style&index=0&id=583c35b0&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__